// FILE: src/utils/firebase/features/budgets/fetchers.js

import { COLLECTIONS } from "../../core/collections";
import * as emailScoped from "../../core/emailScoped";
import { getOrFetchWithMeta, invalidate as _invalidate } from "../../cache/getOrFetch";

/* ---------- TTLs ---------- */
const TTL_BUDGETS = Number(process.env.REACT_APP_TTL_BUDGETS_MS) || 60 * 60 * 1000; // 1h

/**
 * subscribeUserBudgets
 * Mirror of Accounts subscribe; streams user budgets by email.
 *
 * @param {Object} opts
 * @param {string} opts.userEmail
 * @param {number} [opts.cap]
 * @param {(items:any[]) => void} opts.onData
 * @param {(err:any) => void} [opts.onError]
 * @returns {() => void} unsubscribe
 */
export function subscribeUserBudgets({ userEmail, cap, onData, onError }) {
  return emailScoped.subscribeByEmailHelper({
    colName: COLLECTIONS.userBudgets,
    userEmail,
    cap,
    extra: [],
    onData,
    onError,
  });
}

/**
 * fetchUserBudgetsOnce
 * TTL-cached one-shot fetch; persists to local cache under `budgets:<email>`.
 *
 * @param {Object} opts
 * @param {string} opts.userEmail
 * @param {number} [opts.cap]
 * @param {number} [opts.ttlMs]
 * @returns {Promise<{ items: any[], meta: any }>}
 */
export function fetchUserBudgetsOnce({ userEmail, cap, ttlMs } = {}) {
  const key = `budgets:${userEmail}`;
  return getOrFetchWithMeta({
    key,
    ttlMs: ttlMs ?? TTL_BUDGETS,
    persist: true,
    persistKey: key,
    fetcher: () => emailScoped.fetchByEmailOnce(COLLECTIONS.userBudgets, userEmail, { cap }),
  });
}

/* ---------- Cache Invalidator ---------- */
export function invalidateBudgetsCache(userEmail) {
  _invalidate(`budgets:${userEmail}`);
}
